export default __webpack_public_path__ + "static/media/standard-text-challenge.0e1a2fd2.png";